import React from "react";

import { MyCompaniesList } from "../../../components/admin/u1/mycompanies/MyCompaniesList";
import { StateLegend, CLAIMED_STEPS } from "../../../components/common/static/u1/StateLegend";
import { OwnerCard } from "../../../components/common/static/u1/OwnerCard";
import { ResearcherCard } from "../../../components/common/static/u1/ResearcherCard";
import "../../../components/common/u1/tokens.css";

/* u1 My Companies — TIP-632.
 *
 * Visual uplift only. The list's data handling is transcribed in
 * MyCompaniesList; the rail reuses the cards the search page already has.
 *
 * The legend drops its "Listed" step here: this screen only ever shows
 * businesses the user has claimed, so a step describing an unclaimed profile
 * has nothing to point at.
 */
export default function MyCompany() {
  return (
    <div className="u1-root grid grid-cols-1 items-start gap-[22px] pb-6 pt-5 sm:pt-[26px] lg:grid-cols-[minmax(0,1fr)_340px]">
      <div className="min-w-0">
        <MyCompaniesList />
      </div>

      <aside className="flex min-w-0 flex-col gap-4">
        <StateLegend
          eyebrow="Reading your companies"
          steps={CLAIMED_STEPS}
          intro="Every business you manage has one status. It shows how far it has come on TREVEX."
        />
        <OwnerCard />
        <ResearcherCard />
      </aside>
    </div>
  );
}
